import React from "react";
import {Link} from "react-router-dom";


export default function Home() {
    return (
        <>
            <div className="pt-6 pb-24">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                            Conversation prompts for deeper connections
                        </h2>
                        <p className="mt-4 text-lg/8 text-gray-600">Play with friends, on a date, or use as journal
                            prompts for self-reflection.</p>

                        <Link to={'/about'} className="mt-4 relative inline-flex items-center justify-center rounded-md min-w-32
                            bg-green-500 text-white
                            px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300
                            hover:bg-blue-950
                            focus-visible:outline-offset-0">Save & use offline</Link>
                    </div>
                    <div
                        className="mx-auto mt-4 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">

                        <Link to="/money">
                            <div className="overflow-hidden rounded-lg shadow bg-blue-950">
                                <div
                                    className="px-4 py-5 sm:p-6 text-balance text-2xl font-semibold tracking-tight text-white sm:text-5xl text-center ">
                                    Let's Talk About Money
                                </div>
                            </div>
                        </Link>

                        <Link to="/business">
                            <div className="overflow-hidden rounded-lg shadow bg-blue-200">
                                <div
                                    className="px-4 py-5 sm:p-6 text-balance text-2xl font-semibold tracking-tight text-white sm:text-5xl text-center">
                                    Let's Talk About Business
                                </div>
                            </div>
                        </Link>

                        <Link to="/connect">
                            <div className="overflow-hidden rounded-lg shadow bg-amber-300">
                                <div
                                    className="px-4 py-5 sm:p-6 text-balance text-2xl font-semibold tracking-tight text-white sm:text-5xl text-center">
                                    Connect More Deeply
                                </div>
                            </div>
                        </Link>


                    </div>
                </div>
            </div>
        </>
    )
}
